// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1OOvq","box":"WorkspacesBox_box__2NKiI","node":"WorkspacesBox_node__ILoPH"};